import { SubRouteAttributes } from '@albatrosdeveloper/ave-models-package';
import { Injectable, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject, take } from 'rxjs';
import { SubRouteService } from '../sub-route.service';

/**
 * Service for the sub-route partners layout.
 * Only manages subRouteId and subRouteData.
 * viewMode, grouping, and search are managed by AssignedPartnersPanelService.
 */
@Injectable()
export class SubRoutePartnersLayoutService {
  private subRouteService = inject(SubRouteService);

  // === STATE SIGNALS ===
  private _subRouteId = signal<string>('');
  private _subRouteData = signal<SubRouteAttributes | null>(null);

  // === ACTION SUBJECTS ===
  readonly setSubRouteId$ = new Subject<string>();
  readonly setSubRouteData$ = new Subject<SubRouteAttributes>();

  /** Emitir para refrescar el panel de asignados (cuando se asigna frecuencia desde sin asignar) */
  readonly refreshAssignedPartners$ = new Subject<void>();

  // === PUBLIC COMPUTED ===
  readonly subRouteId = computed(() => this._subRouteId());
  readonly hasSubRouteId = computed(() => !!this._subRouteId());
  readonly subRouteData = computed(() => this._subRouteData());

  constructor() {
    // Handle subRouteId changes
    this.setSubRouteId$.pipe(takeUntilDestroyed()).subscribe((id) => {
      this._subRouteId.set(id);
      if (id) {
        this.fetchSubRouteData(id);
      } else {
        this._subRouteData.set(null);
      }
    });

    // Handle direct subRouteData updates
    this.setSubRouteData$.pipe(takeUntilDestroyed()).subscribe((data) => {
      this._subRouteData.set(data);
    });
  }

  /** Fetch full subRoute data from API */
  private fetchSubRouteData(subRouteId: string): void {
    this.subRouteService
      .findOne(subRouteId)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this._subRouteData.set(response.data);
        },
        error: () => {
          this._subRouteData.set(null);
        },
      });
  }
}
